import React from "react";
import '../i18n/translate';

const TTLegend = ({t}) => {
    return (<svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="100%"
      height="100%"
      preserveAspectRatio="none"
      viewBox="0 0 640 400"
    >
      <defs>
        <path
          id="a"
          fill="#333"
          fillOpacity="0.667"
          d="M205.9 277.75l10.9 10.3 3.8-14.3-.4-1.05-14.3 5.05z"
        />
        <path
          id="c"
          fill="#333"
          fillOpacity="0.667"
          d="M279.6 256.55l-7.35 13.25 15 .45-6.6-13.2-1.05-.5z"
        />
        <path
          id="e"
          fill="#333"
          fillOpacity="0.667"
          d="M366.75 229.5l-1.05-.55-7.25 13.3 15 .4-6.7-13.15z"
        />
        <path
          id="h"
          fill="#333"
          fillOpacity="0.667"
          d="M411.55 224.55l-5.6 14.1 14.9-1.45-8.2-12.25-1.1-.4z"
        />
        <path
          id="k"
          fill="#333"
          fillOpacity="0.667"
          d="M447.7 218.4l13.7-6.1-11.65-9-1.2-.05-.85 15.15z"
        />
        <path
          id="m"
          fill="#333"
          fillOpacity="0.667"
          d="M519.7 178.05l-.85.8 10.2 11.25 5.3-14.05-14.65 2z"
        />
        <path
          id="o"
          fill="#333"
          fillOpacity="0.667"
          d="M200.25 172.05l.75 15 12.6-7.65.45-1.1-13.8-6.25z"
        />
        <path
          id="q"
          fill="#333"
          fillOpacity="0.667"
          d="M481.5 191.55l-1.15.25 3 14.9 11.7-9.35-13.55-5.8z"
        />
        <path
          id="t"
          fill="#333"
          fillOpacity="0.667"
          d="M149.25 233l4.65 14.25 10.2-10.7.15-1.15-15-2.4z"
        />
        <path
          id="b"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M259.349 222.376l-46.195 49.694"
        />
        <path
          id="d"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M307.7 213.293l-1.733 67.825"
        />
        <path
          id="f"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M368.915 193.359l-.035.424"
        />
        <path
          id="g"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M368.526 193.783l-6.326 126.39"
        />
        <path
          id="i"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M402.386 190.107l.035.46"
        />
        <path
          id="j"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M402.068 190.566l8.093 94.616"
        />
        <path
          id="l"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M431.262 174.626l27.886 61.852"
        />
        <path
          id="n"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M485.797 151.83l63.655 23.468"
        />
        <path
          id="p"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M251.75 149.32l-67.754 3.676"
        />
        <path
          id="r"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M455.649 164.695l.318.353"
        />
        <path
          id="s"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M455.649 165.225l58.317 74.964"
        />
        <path
          id="u"
          fill="none"
          stroke="#666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M217.113 192.122l-64.397 21.453"
        />
      </defs>
      <g transform="translate(28.15 146.05)">
        <clipPath id="v">
          <path fill="#FFF" d="M-2 -2H133V19.05H-2z" />
        </clipPath>
        <text clip-path="url(#v)" writingMode="lr">
          <tspan
            x="9.95"
            y="14.1"
            fill="#666"
            baselineShift="0%"
            fontFamily="Verdana"
            fontSize="14"
            fontWeight="bold"
          >{t("tt_legend1")}
          </tspan>
        </text>
      </g>
      <g transform="translate(18.15 210.05)">
        <clipPath id="w">
          <path fill="#FFF" d="M-2 -2H133V19.05H-2z" />
        </clipPath>
        <text clip-path="url(#w)" writingMode="lr">
          <tspan
            x="9.8"
            y="14.1"
            fill="#666"
            baselineShift="0%"
            fontFamily="Verdana"
            fontSize="14"
            fontWeight="bold"
          >
           {t("tt_legend2")} 
          </tspan>
        </text>
      </g>
      <g transform="translate(68.15 276.05)">
        <clipPath id="x">
          <path fill="#FFF" d="M-46.1 -2H133V19.05H-46.1z" />
        </clipPath>
        <text clip-path="url(#x)" writingMode="lr">
          <tspan
            x="-34.9"
            y="14.1"
            fill="#666"
            baselineShift="0%"
            fontFamily="Verdana"
            fontSize="14"
            fontWeight="bold"
          >
            {t("tt_legend3")}
          </tspan>
        </text>
      </g>
      <g transform="translate(218.15 296.05)">
        <clipPath id="y">
          <path fill="#FFF" d="M-2 -2H133V19.05H-2z" />
        </clipPath>
        <text clip-path="url(#y)" writingMode="lr">
          <tspan
            x="32.1"
            y="14.1"
            fill="#666"
            baselineShift="0%"
            fontFamily="Verdana"
            fontSize="14"
            fontWeight="bold"
          >
            {t("tt_legend4")}
          </tspan>
        </text>
      </g>
      <g transform="translate(298.15 336.05)">
        <clipPath id="z">
          <path fill="#FFF" d="M-2 -2H101.85V38.1H-2z" />
        </clipPath>
        <text clip-path="url(#z)" writingMode="lr">
          <tspan
            x="6.5"
            y="14.1"
            fill="#666"
            baselineShift="0%"
            fontFamily="Verdana"
            fontSize="14"
            fontWeight="bold"
          >
          {t("tt_legend5")}
          </tspan>
        </text>
      </g>
      <g transform="translate(378.15 296.05)">
        <clipPath id="A">
          <path fill="#FFF" d="M-2 -2H133V38.1H-2z" />
        </clipPath>
        <text clip-path="url(#A)" writingMode="lr">
          <tspan
            x="10.55"
            y="14.1"
            fill="#666"
            baselineShift="0%"
            fontFamily="Verdana"
            fontSize="14"
            fontWeight="bold"
          >
            {t("tt_legend6")}
          </tspan>
        </text>
      </g>
      <g transform="translate(418.15 256.05)">
        <clipPath id="B">
          <path fill="#FFF" d="M-2 -2H98.85V19.05H-2z" />
        </clipPath>
        <text clip-path="url(#B)" writingMode="lr">
          <tspan
            x="25.9"
            y="14.1"
            fill="#666"
            baselineShift="0%"
            fontFamily="Verdana"
            fontSize="14"
            fontWeight="bold"
          >
            {t("tt_legend7")}
          </tspan>
        </text>
      </g>
      <g transform="translate(498.15 256.05)">
        <clipPath id="C">
          <path fill="#FFF" d="M-2 -2H98.85V19.05H-2z" />
        </clipPath>
        <text clip-path="url(#C)" writingMode="lr">
          <tspan
            x="26.3"
            y="14.1"
            fill="#666"
            baselineShift="0%"
            fontFamily="Verdana"
            fontSize="14"
            fontWeight="bold"
          >
            {t("tt_legend8")}
          </tspan>
        </text>
      </g>
      <g transform="translate(518.15 193.05)">
        <clipPath id="D">
          <path fill="#FFF" d="M-2 -2H98.85V19.05H-2z" />
        </clipPath>
        <text clip-path="url(#D)" writingMode="lr">
          <tspan
            x="38.3"
            y="14.1"
            fill="#666"
            baselineShift="0%"
            fontFamily="Verdana"
            fontSize="14"
            fontWeight="bold"
          >
            {t("tt_legend9")}
          </tspan>
        </text>
      </g>
    </svg>
    );
}

export default TTLegend;
